import { Form, Input, message, Modal } from "antd";
import { useState } from "react";
import { passwd } from "../API/Auth";

export interface ChangePasswordModalProps {
  /** Whether the modal is currently visible */
  visible: boolean;

  /** Called by the modal to hide itself */
  onHide(): void;
}

export const ChangePasswordModal: React.FC<ChangePasswordModalProps> = (
  props
) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const changePassword = async () => {
    // Validate fields
    try {
      await form.validateFields();
    } catch (err) {
      console.warn("ChangePassword: Form failed validation.");
      return;
    }

    // Collect values
    const email = localStorage.getItem("email");
    if (email === null) {
      console.error(
        "Tried to change password but user is not logged in? Email is null in localStorage."
      );
      message.error(
        "Something went wrong with changing your password. Please logout, login and try again."
      );
      return;
    }
    const password = form.getFieldValue("password");
    const newPassword = form.getFieldValue("newPassword");

    // Make request
    setLoading(true);
    const result = await passwd(email, password, newPassword);
    setLoading(false);

    switch (result) {
      case "ok":
        message.success("Password changed!");
        props.onHide();
        break;
      case "bad-password":
        message.error("Wrong current password.");
        break;
      case "network-error":
        message.error(
          "Could not communicate with server. Please try again later."
        );
        break;
      default:
        message.error("Unknown error occured, please try again later.");
        break;
    }
  };

  return (
    <Modal
      title="Change account password"
      visible={props.visible}
      confirmLoading={loading}
      cancelButtonProps={{ disabled: loading }}
      onCancel={props.onHide}
      onOk={() => changePassword()}
    >
      <Form form={form}>
        <Form.Item
          name="password"
          label="Current password"
          rules={[
            { required: true, message: "The current password is required." },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="New password"
          rules={[{ required: true, message: "The new password is required." }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="newPasswordRepeat"
          label="Repeat new password"
          rules={[
            { required: true, message: "Please repeat the new password." },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The two passwords that you entered do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};
